export const defaultWalletAllSelector = (state) =>
  state?.defaultWalletReducer?.defaultWalletAll;
